import React from 'react';
import { ReactComponent as GPCProjectIcon } from 'images/google-project.svg';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import { useIsItemSelected, useSmartNestedDepth, useToggleProjectSelection } from './hooks';

export const ChildItem = ({ title, id, folder }) => {
  const { paddingLeft } = useSmartNestedDepth();
  const checkId = `project-id-check-${id}`;
  const { selected } = useIsItemSelected(id, folder) || {};
  const onSelect = useToggleProjectSelection();
  return (
    <ListGroup.Item as="li" aria-label={`GCP Project ${title}`}>
      <div className="rax-mgcp-child-listitem-grid" style={{ paddingLeft }}>
        <Form.Check value={id} id={checkId} checked={selected} onChange={onSelect} />
        <GPCProjectIcon role="img" title="GCP Project" className="project-icon" />
        <div className="project-title mb-none text-truncate" title={title}>{title}</div>
        <small className="project-id text-muted text-truncate" title={id}>{id}</small>
      </div>
    </ListGroup.Item>
  );
};

// if we are going to deviate so much from the default ListGroups in react-bootstrap, maybe we should just use uls and lis, and provide our own classes?
